module.exports = __webpack_public_path__ + "static/media/inbox.92118235.svg";